//文字コードはutf-8

/* XJStorage設定・初期化
========================================================*/
export function initXjstorageConfig() {
    var groupCode = {
        '決算短信': [1, 2, 3, 4, 16, 17, 18, 19, 20, 21],
        '適時開示': [0, 5, 6, 8, 9, 15, 24, 25, 28],
        '決算説明資料': [13, 98],
        '有価証券報告書・四半期報告書': [99, 105, 106, 107, 108, 1120, 1130, 1140, 1150, 1160, 1170],
        'その他 法定開示資料': [1030, 1040, 1080, 1090, 1100, 1135, 1136, 1180, 1190, 1200, 1210, 1220, 1230, 1235, 1236, 1240, 1250, 1260, 1270, 1280, 1290, 1300, 1310, 1320, 1350, 1360],
        '株主通信': [96, 101, 102, 103, 104],
        '招集通知': [34, 91],
        '招集通知添付資料等': [111],
        '決議通知': [112],
        '株主総会関連資料': [91, 111, 112],
        'その他IR資料': [90, 92, 93, 95, 97, 110, 113, 114, 115, 116, 117, 118, 119, 120],
        'コーポレート・ガバナンス': [109],
        '決算公告': [94],
        '電子公告': [94, 100],
        'ニューストピックス': [201]
    };

    function unique(items) {
        var result = [];
        var seen = {};
        for (var i = 0; i < items.length; i++) {
            if (seen[items[i]]) continue;
            seen[items[i]] = true;
            result.push(items[i]);
        }
        return result;
    }

    var groupLabel = {
        '適時開示': {
            id: 2,
            doctype: unique([].concat(groupCode['適時開示'], 13))
        },
        '決算短信': {
            id: 1,
            doctype: groupCode['決算短信']
        },
        '法定開示': {
            id: 3,
            doctype: unique([].concat(groupCode['有価証券報告書・四半期報告書'], groupCode['その他 法定開示資料']))
        },
        'IR資料': {
            id: 4,
            doctype: unique([].concat(groupCode['株主通信'], groupCode['株主総会関連資料'], groupCode['その他IR資料'], 91, 96, 98, 101, 102, 103, 104, 111, 112))
        },
        'お知らせ': {
            id: 5,
            doctype: [14, 200]
        }
    };

    window.IR_CONFIG = {
        COMPANY_CODE: 'AS01638',
        API_URL: 'https://www.xj-storage.jp/public-list/GetList.aspx',
        FIRST_DATE: '2006/03/31',
        FIRST_PERIOD: 0,
        groupCode: groupCode,
        groupLabel: groupLabel
    };

    if (window.require) {
        window.require(['xjstorage'], function (XJStorage) {
            var xj;

            if (!XJStorage) return;

            xj = new XJStorage();
            xj.company = window.IR_CONFIG.COMPANY_CODE;
            xj.firstDate = window.IR_CONFIG.FIRST_DATE;
            xj.firstPeriod = window.IR_CONFIG.FIRST_PERIOD;
            xj.groupCode = groupCode;
            xj.groupLabel = groupLabel;

            window.IR_XJ = xj;
        });
    }
}
